import type { IBaseSkuCharacteristicValue, IImageSkuCharacteristic, TSkuCharacteristic, TSkuSelectedIds } from '../models/sku-characteristic';

import type { ISkuItem } from './product-to-sku-list';

/**
 * Функция преобразует характеристики продукта. Помечает недоступные характеристики на основе уже выбранных.
 * @param {TSkuCharacteristic[]} characteristics - Список всех характеристик.
 * @param {ISkuItem} currentSku - Выбранный SKU. На основе этого параметра вычисляются выбранные характеристики.
 * @param {ISkuItem[]} skuList - Список всех SKU. На основе этого параметра вычисляется доступна ли характеристика.
 * @return {TSkuCharacteristic[]} Объект корзины.
 */
export function characteristicsToDisabledCharacteristic(
  characteristics: TSkuCharacteristic[],
  currentSku: ISkuItem,
  skuList: ISkuItem[],
): TSkuCharacteristic[] {
  return characteristics.map(({ values, ...characteristic }, index, array) => {
    return {
      ...characteristic,
      values: values.map((charValue: any) => {
        const charValIds = getCharValIds(currentSku);

        charValIds[characteristic.characteristicId] = charValue.valueId;

        const potentialSku = skuList.find((sku) =>
          sku.characteristics.every(
            (characteristic) => charValIds[characteristic.characteristicId] === characteristic.value.valueId,
          ),
        );
        const availableAmount = potentialSku?.availableAmount || 0;

        return { ...charValue, disabled: availableAmount <= 0 };
      }),
    };
  });
}

function getCharValIds(sku: ISkuItem): TSkuSelectedIds {
  return sku.characteristics.reduce(
    (sum, characteristic) => ({
      ...sum,
      [characteristic.characteristicId]: characteristic.value.valueId,
    }),
    {},
  );
}
